import { render, staticRenderFns } from "./user-summary.vue?vue&type=template&id=12ff093d&scoped=true&"
import script from "./user-summary.vue?vue&type=script&lang=js&"
export * from "./user-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff093d",
  null
  
)

export default component.exports